import './App.css';
import Hero from './Hero';
import DeliveryLocations from './DeliveryLocations';
import About from './About';
import MenuShowcase from './MenuShowcase';
import Footer from './Footer';

function App() {
  return (
    <div className="App">
      <Hero />
      <DeliveryLocations />
      <About />
      <MenuShowcase />
      <Footer />
    </div>
  );
}

export default App;
